import React, { useState } from "react";
import styles from "./DemoPerformance.module.css";
import Play from "../../assests/play.svg";
import ProfilePopup from "../Profile/ProfilePopup";

export default function DemoPerformance({ data }) {
  const [showPreview, setShowPreview] = useState(false);
  const [fileUrl, setFileUrl] = useState({});
  const fileData = {
    contestName: "Demo Performance",
    fileType: "video",
    fileUrls: [
      {
        fileUrl: fileUrl?.fileUrl,
        fileType: "video",
        _id: "1",
      },
    ],
    description: fileUrl?.description,
  };
  const handleOpenPreview = (obj) => {
    setFileUrl(obj);
    setShowPreview(true);
  };
  return (
    <div className={`z-10  pt-[30px] mb-[32px] relative w-[100%] `}>
      <div className="flex items-center justify-between">
        <p className="text-large-medium mb-[12px]">Demo Performances</p>
      </div>
      <div className={styles.pureGrid}>
        {data?.map((obj, indexnumber) => {
          return (
            <>
              <div
                onClick={() => handleOpenPreview(obj)}
                className="rounded-[6px]"
              >
                <div className="relative">
                  <img
                    className={styles.gridingg}
                    src={obj.coverImage}
                    alt=""
                  />
                  <img className={styles.playbtn} src={Play} alt="" />
                </div>
              </div>
            </>
          );
        })}
      </div>
      {showPreview && (
        <ProfilePopup
          setShowPreview={setShowPreview}
          singleFileDetails={fileData}
          type="demo"
        />
      )}
    </div>
  );
}
